@if (onboardingVideo) {
  <rt-infobox
    [isBadgeBeforeHeading]="true"
    [heading]="heading"
    [headingBadge]="hasNewBadge ? ('app.common.new' | translate) : ''"
    [imageTemplate]="imageTemplate"
    [messagePaddingSmall]="true"
    [hidden]="hidden"
    [storageKey]="storageKey"
    [attr.margin-bottom-medium]="hidden || !marginBottom ? null : ''"
    (dismissClick)="$event.stopPropagation(); handleDismissClick()"
    (click)="openOnboardingVideo()"
  >
    <ng-template #imageTemplate>
      <div class="video">
        <div class="video--thumbnail">
          <img [src]="onboardingVideo.thumbnail" alt="thumbnail" />
          <div class="video-overlay">
            <div class="icon-container">
              <rt-icon name="play-arrow" />
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    {{ content }}
  </rt-infobox>
}
